import { Button } from "components/Button";
import Stack from "components/Stack";
import Text from "components/Text";
import { useUI } from "state/UIContext";
import { useTranslation } from "react-i18next";
import QRCode from "qrcode.react";
import { useRef } from "react";
import classNames from "classnames";

const QRModal = ({ qrUrl, title }: { qrUrl: string; title: string }) => {
  const { closeModal } = useUI();
  const { t } = useTranslation();
  const qrRef = useRef<HTMLDivElement>(null);

  const downloadQRCode = () => {
    const canvas = qrRef.current?.querySelector("canvas");
    const image = canvas?.toDataURL("image/png") as string;
    const link = document.createElement("a");
    link.href = image;
    link.download = "qrcode.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Stack className="w-[480px] h-[600] p-8 -bg--theme-colors-surface-neutral-level02 -text--theme-colors-text-body -rounded-modals-container">
      <div className="flex flex-col space-y-10">
        <Text className="-text--theme-colors-text-title font-bold text-lg">
          {title}
        </Text>
        <div className="w-full p-16 bg-white flex justify-center" ref={qrRef}>
          <QRCode
            value={qrUrl}
            size={215}
            fgColor="#000000"
            bgColor="#ffffff"
            className={classNames({
              "opacity-10": !qrUrl,
            })}
          />
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-y-4 gap-x-5 ">
          <Button
            variant="secondary"
            onClick={closeModal}
            fullWidth
            className="order-2 md:order-1"
          >
            {t("common.buttons.cancel")}
          </Button>
        </div>
      </div>
    </Stack>
  );
};

export default QRModal;
